import { Url } from 'next/dist/shared/lib/router/router';
import { useEffect, useState } from 'react';

import { SessionData } from '@/lib/sessionsv2/types';

export interface CreatePerms {
	ApprovedToCreate: boolean;
	URLPath: string;
	LoggedIn: boolean;
}

export const useCreateTournamentURL = (session: SessionData | undefined, createPerms: CreatePerms | null | undefined, ssoRedirectUrl?: string) => {
	const [createATournamentURL, setCreateATournamentURL] = useState<Url>('');

	useEffect(() => {
		const continueUrl = ssoRedirectUrl?.trim() || (typeof window !== 'undefined' ? window.location.href : '');

		if (!continueUrl) return;

		if (!session?.user?.uuid) {
			const url = new URL(`${process.env.NEXT_PUBLIC_SSO_ENDPOINT}/`);
			url.searchParams.set('flow', 'SelfService');
			url.searchParams.set('continue', continueUrl);
			setCreateATournamentURL(url);
			return;
		}

		if (createPerms?.ApprovedToCreate) {
			const url = new URL(createPerms.URLPath);
			url.searchParams.set('rurl', continueUrl);
			setCreateATournamentURL(url);
		} else {
			const url = new URL(`https://${process.env.NEXT_PUBLIC_FRONT_URL}`);
			url.hostname = `contact.${url.hostname}`;
			url.pathname += 'contacts/tournament/create';
			setCreateATournamentURL(url);
		}
	}, [session, createPerms, ssoRedirectUrl]);

	return createATournamentURL;
};
